import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, idx) => ({
      '@type': 'ListItem' as const,
      position: idx + 1,
      name: item.label,
      item: item.path ? `http://aywxtna.cn/${item.path}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <ol className="flex items-center gap-1.5 text-xs text-foreground-500 flex-wrap">
            {items.map((item, idx) => (
              <li key={idx} className="flex items-center gap-1.5">
                {idx > 0 && (
                  <span className="text-foreground-300" aria-hidden="true">/</span>
                )}
                {item.path ? (
                  <Link
                    to={item.path}
                    className="hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span className="text-foreground-700 font-medium whitespace-nowrap">{item.label}</span>
                )}
              </li>
            ))}
          </ol>
        </div>
      </nav>
    </>
  );
}